import useFilterActions from "../../hooks/useFilterActions";
import { useAISummaryStore } from "../../store/aiSummaryStore";
import ChipList from "../Fields/ChipList";
import FilterDropdown from "../Fields/FilterDropdown";
import SearchBar from "../Fields/SearchBar";

export default function LeftTopPanel() {
  const { searchText, setSearchText, chipData } = useAISummaryStore();
  const { handleSelection } = useFilterActions();

  return (
    <div className="flex w-full flex-col px-2 pt-7">
      <div className="flex w-full flex-row items-stretch justify-between pb-4">
        <div className="w-2/3">
          <SearchBar searchText={searchText} setSearchText={setSearchText} />
        </div>
        <FilterDropdown chipData={chipData} handleSelection={handleSelection} />
      </div>
      <ChipList />
    </div>
  );
}
